import Vue from 'vue';
import Router from 'vue-router';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import LandingPage from './views/LandingPage.vue';
import Login from './views/Login.vue';
import AppInstall from './views/AppInstall.vue';
import Complete from './views/Complete.vue';
import Relogin from './views/Relogin.vue';
import StepperMeta from './StepperMeta';
import { i18n, setI18nLanguage } from './localizer';
import settings from './config';

Vue.use(Router);

const router = new Router({
  base: settings.VUE_APP_BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: `/${i18n.fallbackLocale}`,
      children: [
        {
          path: 'Login',
          redirect: `/${i18n.fallbackLocale}/Login`,
        },
        {
          path: 'Install',
          redirect: `/${i18n.fallbackLocale}/Install`,
        },
        {
          path: 'Finished',
          redirect: `/${i18n.fallbackLocale}/Finished`,
        },
        {
          path: 'PrivacyPolicy',
          redirect: `/${i18n.fallbackLocale}/PrivacyPolicy`,
        },
        {
          path: 'Relogin',
          redirect: `/${i18n.fallbackLocale}/Relogin`,
        },
      ],
    },
    {
      path: '/:locale',
      beforeEnter: (to, from, next) => {
        const lang = to.params.locale;

        if (lang) {
          setI18nLanguage(lang);
          next();
        }
      },
      component: {
        template: '<router-view />',
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: LandingPage,
        },
        {
          path: 'PrivacyPolicy',
          name: 'PrivacyPolicy',
          component: PrivacyPolicy,
        },
        {
          path: 'Login',
          name: 'Login',
          component: Login,
          meta: new StepperMeta('stepActive', 'stepDisabled'),
        },
        {
          path: 'Install',
          name: 'Install',
          component: AppInstall,
          meta: new StepperMeta('stepComplete', 'stepActive'),
        },
        {
          path: 'Finished',
          name: 'Finished',
          component: Complete,
          meta: new StepperMeta('stepComplete', 'stepComplete'),
        },
        {
          path: 'Relogin',
          name: 'Relogin',
          component: Relogin,
          meta: null,
        },
      ],
    },
  ],
});

export default router;
